<template>
  <div fill-height align-center justify-center>
    跳转中......
  </div>
</template>
<script>
export default {
  name: 'QEntryRedirect',
  data () {
    return {
      confirmCount: 0
    }
  },
  created () {
    this.initSubmitLogin()
  },
  methods: {
    initSubmitLogin: function(){
      // let lastCode = localStorage.getItem('appraisalH5Code')
      // if (lastCode) {
      //   console.log(11)
      //   this.confirmLogin(lastCode)
      //   localStorage.removeItem('appraisalH5Code')
      // } else if (this.$route.query.code) {
      //   console.log(22)
      //   localStorage.setItem('appraisalH5Code', this.$route.query.code)
      //   this.submitLogin()
      // } else {
        console.log(33)
        let codes = window.location.href.match(/code=(\S*)&state/)
        if (codes && codes.length > 1) {
          localStorage.setItem('appraisalH5Code', codes[1])
          this.submitLogin(codes[1])
        }
      // }
    },
    confirmLogin: function(code){
      if (this.confirmCount > 1) {
        this.submitLogin(code)
        return false
      }
      setTimeout(() => {
        this.confirmCount++
        this.$axios.post('/auth/wechat/login/confirm', { code }).then(res => {
          if (res.data.success) {
            this.loginSuccess(res.data.data)
          } else {
            this.confirmLogin(code)
          }
        }).catch(() => {
          // this.$store.commit('snack/error', '登录确认异常')
        })
      }, 1000)
    },
    submitLogin: function(code){
      console.log(code, 'submitLogin', this.$route.query.code, this.$route.params.type)
      this.$http.post('/auth/wechat/login', {
        code: code || this.$route.query.code,
        type: 'web',
      }).then(res => {
        console.log(111111111111)
        localStorage.removeItem('appraisalH5Code')
        if (res.data.success) {
          console.log('xxx')
          this.loginSuccess(res.data.data)
        } else {
          console.log('yyy')
          // this.$store.commit('entry/showDialog', 'qrcodeLogin')
          this.backRouter()
        }
      }).catch(() => {
        // this.$store.commit('snack/error', '登录异常')
      })
    },
    loginSuccess: function(data){
      console.log('return', data)
      if (data.token) {
        // this.$store.commit('entry/hideDialog')
        // this.$store.commit('network/login')
        // this.$store.commit('endea/clearShareK')
        localStorage.setItem('tokenn', data.token);
        this.$store.commit('session/login');
      } else if (data.unionId) {
        localStorage.setItem('appraisalH5UnionId', data.unionId)
      }
      setTimeout(this.backRouter, 1000)
    },
    backRouter: function(){
      window.location.replace(this.$server.htmlRoot + 'index');
    },
  },
}
</script>